import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'

export class RemoveLinkRoute extends ShareRoute<null, null> {
  constructor(private readonly uuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.DELETE
  }

  url(): string {
    return '/api/system/v1/share/links/' + this.uuid
  }

  offline(): Promise<ApiResponse<null>> {
    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
